import { useAuthStore } from './auth.store';

/**
 * Возвращает префикс роутов, основанный на роли текущего пользователя.
 *
 *   /cabinet  — клиент
 *   /manager  — staff (MANAGER / ADMIN / AUDITOR)
 *
 * Используется в общих страницах (ContractsListPage, ShipmentsListPage и т.п.),
 * которые подключены и под /cabinet, и под /manager, чтобы ссылки внутри
 * вели в правильный неймспейс и не получали 403 от ролевых guard'ов API.
 */
export function useRolePrefix(): '/cabinet' | '/manager' {
  const user = useAuthStore((s) => s.user);
  if (!user) return '/cabinet';
  return user.role === 'CLIENT' ? '/cabinet' : '/manager';
}
